import script from "./VideosView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideosView.vue?vue&type=script&lang=ts&setup=true"

import "./VideosView.vue?vue&type=style&index=0&id=207e91a6&lang=scss"

const __exports__ = script;

export default __exports__